---
title: Términos
updated: 2026-10-02
---

## 1. Aceptación de los Términos

Al crear una cuenta o utilizar Draughts Game («el Servicio»), aceptas quedar vinculado por estos Términos de Servicio. Si no estás de acuerdo, por favor no utilices el Servicio.

## 2. Descripción del Servicio

Draughts Game es una plataforma en línea para jugar a las damas en múltiples variantes. El Servicio incluye emparejamiento contra otros jugadores o contra el ordenador, torneos, clasificaciones de jugadores, problemas de táctica y funciones de análisis de partidas.

## 3. Registro de Cuenta

Para acceder a ciertas funciones, debes crear una cuenta proporcionando un nombre de usuario, dirección de correo electrónico y contraseña. Debes verificar tu dirección de correo electrónico antes de poder iniciar sesión. Eres responsable de mantener la confidencialidad de tus credenciales. También puedes jugar como invitado sin registrarte, con funcionalidad limitada.

- Debes tener al menos 16 años para crear una cuenta.
- Solo puedes crear una cuenta por persona.
- Eres responsable de toda la actividad que se realice con tu cuenta.

## 4. Conducta del Usuario

Al utilizar el Servicio, te comprometes a no:

- Utilizar asistencia externa (motores, solucionadores) durante partidas puntuadas.
- Perder partidas intencionadamente para manipular la clasificación (sandbagging).
- Pactar con otros jugadores en los torneos.
- Acosar, amenazar o abusar de otros usuarios.
- Crear varias cuentas para eludir expulsiones o manipular las clasificaciones.
- Intentar explotar errores o vulnerabilidades de la plataforma.
- Utilizar herramientas automatizadas (bots) para jugar sin autorización.

## 5. Juego Limpio

Nos reservamos el derecho de utilizar sistemas automatizados para detectar trampas y juego desleal. Las infracciones pueden dar lugar a advertencias, suspensiones temporales, ajustes de clasificación o expulsiones permanentes, a nuestra discreción.

## 6. Propiedad Intelectual

El Servicio, incluido su diseño, código original, gráficos y contenido, es propiedad de Draughts Game. Los registros de partidas (movimientos, resultados) son datos públicos y pueden compartirse libremente. El contenido generado por los usuarios (nombres de usuario, mensajes de chat) sigue siendo propiedad de sus respectivos autores.

## 7. Disponibilidad y Modificaciones

Nos esforzamos por mantener el Servicio disponible en todo momento, pero no garantizamos un acceso ininterrumpido. Nos reservamos el derecho de modificar, suspender o interrumpir cualquier parte del Servicio en cualquier momento. Podemos actualizar estos Términos ocasionalmente. El uso continuado del Servicio tras los cambios constituye su aceptación.

## 8. Limitación de Responsabilidad

El Servicio se proporciona «tal cual», sin garantías de ningún tipo, expresas o implícitas. No somos responsables de daños indirectos, incidentales o consecuentes derivados del uso del Servicio. Nuestra responsabilidad total no excederá la cantidad que nos hayas pagado en los 12 meses anteriores a la reclamación (si la hubiera).

## 9. Terminación

Puedes eliminar tu cuenta en cualquier momento desde la configuración de tu perfil («Eliminar cuenta») o poniéndote en contacto con nosotros. Podemos cancelar o suspender tu cuenta si incumples estos Términos o adoptas una conducta perjudicial para el Servicio u otros usuarios.

## 10. Contacto

Para preguntas sobre estos Términos, contáctanos en: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
